import { Restaurant } from "api-types";

export const priceFormatterForRestaurant = (restaurant: Restaurant) => {
  // FIXME get current user locale.
  const numberFormat = new Intl.NumberFormat(navigator.language, {
    style: "currency",
    currency: restaurant.currencyCode,
  });

  const priceFormatter = (priceInLowestDenomination: number) => {
    return priceInLowestDenomination > 0
      ? numberFormat.format(
          priceInLowestDenomination / 10 ** restaurant.currencyMinorUnits
        )
      : "";
  };

  return priceFormatter;
};

const availableLanguages = ["en", "es", "fr", "pl"];

export const getShortLangCode = () => {
  const locale = navigator.language;
  const languageCode = locale.split("-")[0];

  const browserLanguage = availableLanguages.includes(languageCode)
    ? languageCode
    : "en";

  return browserLanguage;
};

export const normalizeEmailAddress = (email: string) =>
  email.trim().toLowerCase();

/**
 * Hashes a string using SHA-256 and returns a hex string.
 * This function is designed to be compatible with the Go implementation.
 *
 * This is kept in commons so that the dashboard can use it later to store
 * a user generated PIN.
 *
 * @param input - The string to hash
 * @returns A hex string of the SHA-256 hash
 */
export const hashStaffAppPIN = async (pin: string): Promise<string> => {
  // Use the Web Crypto API to hash the PIN
  const encoder = new TextEncoder();
  const data = encoder.encode(pin);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);

  // Convert the hash to a hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return hashHex;
};

/**
 * Validates a PIN against a hash using SHA-256.
 *
 * @param pin - The PIN to validate
 * @param hash - The hash to validate against
 * @returns A promise that resolves to true if the PIN matches the hash
 */
export const validateStaffAppPIN = async (
  pin: string, // this is what the user enters
  hash: string // this is what the API returns
): Promise<boolean> => {
  const pinHash = await hashStaffAppPIN(pin);
  return pinHash === hash;
};
